import { Link } from "react-router-dom";
import { allCategories } from "@/lib/catalog";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-3 md:gap-4 lg:grid-cols-6">
      {allCategories.map((category) => (
        <Link
          key={category.slug}
          to={`/category/${category.slug}`}
          className="group flex cursor-pointer flex-col justify-between rounded-lg border border-background-300/60 bg-background-100 p-4 transition-colors hover:border-accent-500/70 hover:bg-background-200/60"
        >
          <div>
            <span className="flex h-10 w-10 items-center justify-center rounded-full border border-primary-700/60 bg-primary-900/30 text-accent-400 transition-colors group-hover:border-accent-500/60">
              <i className={`${category.icon} text-base`} />
            </span>
            <h3 className="mt-4 font-heading text-sm font-semibold text-foreground-100 group-hover:text-accent-400">
              {category.name}
            </h3>
            <p className="mt-0.5 text-[10px] uppercase tracking-widest2 text-foreground-600 font-label">{category.en}</p>
          </div>
          <p className="mt-4 line-clamp-2 text-[11px] leading-relaxed text-foreground-500">{category.summary}</p>
        </Link>
      ))}
    </div>
  );
}